'use client'

import { formatImageURL } from "@/utils/util"
import { getBranchOpenStatus, summariseWorkingHours } from "@/utils/branch"

const focusRing = 'focus-visible:outline-1 focus-visible:outline-offset-4 focus-visible:outline-foreground'
const sweepLink = `pb-0.5 bg-[linear-gradient(currentColor,currentColor)] bg-no-repeat bg-position-[0_100%] bg-size-[100%_1px] hover:bg-size-[0%_1px] transition-[background-size] duration-500 ease-out motion-reduce:transition-none ${focusRing}`

export default function BranchCard({ branch }: { branch: any, vendor?: any, index?: number }) {
  const status = getBranchOpenStatus(branch?.workingHours)
  const hoursRows = summariseWorkingHours(branch?.workingHours)
  const phones = [branch?.phone, ...(Array.isArray(branch?.additionalPhones) ? branch.additionalPhones : [])].filter(Boolean)
  const hasCoords = !!(branch?.latitude && branch?.longitude)
  const mapQuery = hasCoords ? `${branch.latitude},${branch.longitude}` : branch?.address
  const mapHref = mapQuery ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(mapQuery)}` : null

  return (
    <article className="flex flex-col">
      <div className="aspect-4/3 bg-muted overflow-hidden">
        <img src={formatImageURL(branch?.image || 'placeholder.png')} alt="" loading="lazy" className="w-full h-full object-cover" />
      </div>

      <div className="pt-5 flex flex-col flex-1">
        <div className="flex items-start justify-between gap-4">
          <h2 className="text-lg tracking-tight text-foreground">{branch.name}</h2>
          <span className={`shrink-0 mt-1 inline-flex items-center gap-1.5 text-[11px] tracking-[0.14em] uppercase ${status.open ? 'text-foreground' : 'text-muted-foreground'}`}>
            <span aria-hidden className={`size-1.5 rounded-full ${status.open ? 'bg-foreground' : 'bg-muted-foreground'}`} />
            {status.open ? 'Нээлттэй' : 'Хаалттай'}
          </span>
        </div>
        {branch.isDefault && <span className="mt-2 w-fit inline-flex items-center h-5 px-2 border border-foreground text-[10px] tracking-wide">Үндсэн салбар</span>}

        {branch.address && <p className="mt-3 text-sm leading-relaxed text-muted-foreground">{branch.address}</p>}

        {(phones.length > 0 || hoursRows.length > 0) && (
          <div className="mt-5 pt-5 border-t border-border space-y-4 text-[13px]">
            {phones.length > 0 && (
              <div className="flex flex-wrap gap-x-4 gap-y-1">
                {phones.map((p: string, i: number) => <a key={i} href={`tel:${p}`} className={`tabular-nums ${sweepLink}`}>{p}</a>)}
              </div>
            )}
            {hoursRows.length > 0 && (
              <dl className="space-y-1">
                {hoursRows.map((r, i) => (
                  <div key={i} className="flex items-baseline justify-between gap-4">
                    <dt className="text-muted-foreground">{r.day}</dt>
                    <dd className="tabular-nums">{r.time}</dd>
                  </div>
                ))}
              </dl>
            )}
          </div>
        )}

        {(branch.phone || mapHref) && (
          <div className="mt-auto pt-6 flex items-center gap-6 text-[13px]">
            {branch.phone && <a href={`tel:${branch.phone}`} className={sweepLink}>Залгах</a>}
            {mapHref && <a href={mapHref} target="_blank" rel="noopener noreferrer" className={sweepLink}>Газрын зураг</a>}
          </div>
        )}
      </div>
    </article>
  )
}
